import type { DefaultOptions } from "@tanstack/react-query";
import { toast } from "sonner";

import { getApiErrorMessage, isApiError } from "~/lib/apiClient";

export const shouldRetryQuery = (failureCount: number, error: unknown): boolean => {
  // An abort is not a failure — retrying it re-issues work a navigation or
  // unmount just cancelled, turning cancellation into extra load.
  if (error instanceof DOMException && error.name === "AbortError") {
    return false;
  }

  if (isApiError(error) && error.status !== undefined && error.status < 500) {
    return false;
  }

  return failureCount < 2;
};

export const getQueryRetryDelay = (attemptIndex: number): number =>
  Math.min(1_000 * 2 ** attemptIndex, 30_000);

export const queryDefaults: DefaultOptions = {
  queries: {
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: shouldRetryQuery,
    retryDelay: getQueryRetryDelay,
    refetchOnWindowFocus: false,
  },
  mutations: {
    // Catch-all for mutations that don't define their own onError.
    // Mutations with a local onError handler will use that instead.
    onError(error: unknown) {
      toast.error(getApiErrorMessage(error, "Something went wrong"));
    },
  },
};
